import React from "react";
import { Box } from "@material-ui/core";
import { Typography } from "../atom/Typography";

function PrivacyPolicyPage(props) {
	return (
		<Box>
			<Typography component="h1">Privacy Policy — 3MP Monitoring</Typography>
			<p class="updated">Last updated: June 12, 2026</p>

			<h2>1. Introduction</h2>
			<p>
				3MP Monitoring (the "App", "we", "us", "our") is a field-work management
				and monitoring tool intended for organizations (employers) and their
				employees and associates. This policy explains what data we collect, how
				we use it, who we share it with, and your rights.
			</p>
			<p>
				<strong>Data controller:</strong> 3MP MONITORING DOO, Bulevar Zorana
				Đinđića 85/B2, Belgrade, Serbia, Tax ID (PIB): 112392145, Registration
				No. (MB): 21664120. Contact:{" "}
				<a href="mailto:podrska@3mpmonitoring.rs">podrska@3mpmonitoring.rs</a>.
			</p>
			<p>
				<strong>Business (B2B) context:</strong> Accounts in the App are created
				by administrators of your organization. The organization that issued
				your account (your employer) is also a controller of your data within
				the employment relationship and uses the App to organize and monitor
				work.
			</p>

			<h2>2. Data We Collect</h2>
			<ul>
				<li>
					<strong>Account and personal data:</strong> first name, last name,
					email address, phone number, role (USER/ADMIN), profile photo.
				</li>
				<li>
					<strong>Location:</strong> precise GPS location of the device (see
					Section 4).
				</li>
				<li>
					<strong>Device identifiers:</strong> a device identifier (ANDROID_ID)
					and a push-notification token (Firebase Cloud Messaging).
				</li>
				<li>
					<strong>Content you provide:</strong> tasks, comments, sites,
					locations, contractor and team member details, and photos and
					files/documents you attach.
				</li>
				<li>
					<strong>Technical data:</strong> crash logs, diagnostics, and usage
					data (in-app interactions).
				</li>
			</ul>

			<h2>3. How We Use Data</h2>
			<ul>
				<li>
					Providing App functionality (managing tasks, sites, locations, and
					teams).
				</li>
				<li>Creating and managing accounts and authenticating users.</li>
				<li>
					Tracking worker location for the purpose of organizing and monitoring
					work.
				</li>
				<li>Sending work-related notifications (push notifications).</li>
				<li>
					Analytics, bug fixing, and improving App stability and performance.
				</li>
			</ul>

			<h2>4. Location</h2>
			<div class="note">
				<p>
					The App collects the <strong>precise</strong> location of your device.
					Location is collected while you are signed in and using the App,
					including in the background via a service with a
					<strong>persistent notification</strong> that informs you tracking is
					active.
				</p>
				<p>
					Location is sent to our servers together with the device identifier
					and is
					<strong>
						visible to administrators/managers of your organization
					</strong>{" "}
					for work-monitoring purposes. Location is required for the App's core
					function — sign-in is not possible without granting the location
					permission. By using the App you consent to this collection.
				</p>
			</div>

			<h2>5. Data Sharing and Third Parties</h2>
			<p>We do not sell your personal data. We share data with:</p>
			<ul>
				<li>
					<strong>Your organization (employer)</strong> — account, location, and
					work data.
				</li>
				<li>
					<strong>Service providers (processors)</strong> who process data on
					our behalf:
					<ul>
						<li>
							Google Firebase (Analytics, Crashlytics, Cloud Messaging) —
							analytics, crash reports, and push notifications.
						</li>
						<li>Google Maps Platform — displaying maps and locations.</li>
						<li>Amazon Web Services (AWS) — storage of photos and files.</li>
					</ul>
				</li>
				<li>
					<strong>Competent authorities</strong> where required by law.
				</li>
			</ul>

			<h2>6. Data Retention</h2>
			<p>
				We retain data while your account is active and for as long as necessary
				for the purposes described in this policy, or as required by applicable
				law. After account deletion, we delete personal data (see Section 8),
				and backups within 90 days.
			</p>

			<h2>7. Security</h2>
			<p>
				All data is transmitted over an encrypted connection (HTTPS/TLS). We
				apply reasonable technical and organizational measures to protect
				against unauthorized access, loss, or misuse.
			</p>

			<h2>8. Your Rights and Account Deletion</h2>
			<p>
				You have the right to access, correct, and delete your data, as well as
				to object to and restrict processing in accordance with applicable laws.
			</p>
			<p>
				Accounts are created and managed by your organization, and account and
				data deletion is governed by the agreement between your organization and
				3MP MONITORING DOO. To request deletion of your account and associated
				data, contact your organization's administrator or email
				<a href="mailto:podrska@3mpmonitoring.rs">
					podrska@3mpmonitoring.rs
				</a>{" "}
				(subject: "Account Deletion Request").
			</p>
			<p>
				Upon a valid request we delete your personal data — name, email, phone
				number, profile photo, location history, and device identifiers.
				Business content created in the App (e.g., tasks, comments, sites) may
				be retained or anonymized as required by your organization, and records
				we are legally required to keep are retained for the mandated period.
				Backups are purged within 90 days.
			</p>

			<h2>9. Children</h2>
			<p>
				The App is intended solely for adults (18+) in a business context. We do
				not knowingly collect data from children.
			</p>

			<h2>10. Changes to This Policy</h2>
			<p>
				We may update this policy from time to time. The date of the last update
				is shown at the top of this page. We will notify you of significant
				changes through the App or by email.
			</p>

			<h2>11. Contact</h2>
			<p>
				3MP MONITORING DOO
				<br />
				Email:{" "}
				<a href="mailto:podrska@3mpmonitoring.rs">podrska@3mpmonitoring.rs</a>
			</p>
		</Box>
	);
}

PrivacyPolicyPage.displayName = "PrivacyPolicyPage";
export default PrivacyPolicyPage;
